import { Component } from '@theme/component';

/** Copy-to-photo windows and gentle viewport entrances; no page-position changes. */
class ProjectPetEditorial extends Component {
  /** @type {{ reveal?: HTMLElement[] }} */
  refs;

  connectedCallback() {
    super.connectedCallback();
    this.classList.add('pp-editorial--interactive');
    this.revealAbort?.abort();
    this.revealAbort = new AbortController();
    this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
    document.addEventListener('projectpet:motion-change', () => this.observeMedia(), { signal: this.revealAbort.signal });
    this.motionPreference.addEventListener('change', () => this.observeMedia(), { signal: this.revealAbort.signal });
    this.addEventListener('focusin', event => {
      if (!(event.target instanceof Element)) return;
      const media = event.target.closest('[data-pp-reveal]') || event.target.closest('a')?.querySelector('[data-pp-reveal]');
      if (media) this.revealMedia(media);
    }, { signal: this.revealAbort.signal });
    this.observeMedia();
  }

  updatedCallback() {
    super.updatedCallback();
    this.observeMedia();
  }

  observeMedia() {
    this.revealObserver?.disconnect();
    const animate = !this.motionPreference?.matches && document.documentElement.dataset.ppMotionPaused !== 'true' && 'IntersectionObserver' in window;
    this.classList.toggle('pp-editorial--motion', animate);
    if (!animate) return;
    this.revealObserver = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) this.revealMedia(entry.target);
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    for (const media of this.refs.reveal || []) {
      if (!media.hasAttribute('data-pp-visible')) this.revealObserver.observe(media);
    }
  }

  revealMedia(media) {
    media.setAttribute('data-pp-visible', '');
    this.revealObserver?.unobserve(media);
  }

  /** @param {MouseEvent} event */
  togglePhoto(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-pp-photo-toggle]');
    if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
    const opening = button.getAttribute('aria-pressed') !== 'true';
    for (const toggle of this.querySelectorAll('[data-pp-photo-toggle]')) {
      toggle.setAttribute('aria-pressed', toggle === button && opening ? 'true' : 'false');
    }
  }

  /** @param {KeyboardEvent} event */
  handleWindowKey(event) {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const button = event.target.closest('[data-pp-photo-toggle]');
    if (!button) return;
    button.setAttribute('aria-pressed', 'false');
  }

  disconnectedCallback() {
    this.revealAbort?.abort();
    this.revealObserver?.disconnect();
    super.disconnectedCallback();
  }
}

if (!customElements.get('pp-home-editorial')) customElements.define('pp-home-editorial', ProjectPetEditorial);
